<template>
  <div :class="{selectitemstyle:isfocus}"
       :style="{marginTop:getMarginTop(),marginLeft:getMarginLR(),marginRight:getMarginLR()}"
       class="base_obj_style relative top-0 left-0"
       ref="sss"
       v-resize="handleResize">
    <!--class="bg-white"-->
    <slot></slot>
    <div :class="{selectitemstyleleft:isfocus}" :style="{top:getTop()}" class=""
         ref="left"
         style="width: 40px;position: absolute;left: -62px;top:30px;"
         v-if="showButton">
      <div class="flex a-center j-center p-v-20 "
           style="width: 40px;writing-mode: vertical-lr;
      color: #3B80FF;white-space: nowrap;background: #FFFFFF;box-shadow: 0px 0px 8px 0px rgba(101, 151, 230, 0.36);
      border-radius: 20px;">
        <span class="m-t-4 bold"
              style="color:#3B80FF;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;letter-spacing:4px;position: absolute;left: -30px;top:30px;"
              v-if="iteminfo.typename">{{
            iteminfo.typename
          }}</span>
        <span class="m-t-4"
              style="color:#4B8AFF;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;letter-spacing:4px"
              v-if="iteminfo.name">{{
            iteminfo.name
          }}</span>
      </div>
    </div>
    <div :style="{top:getTop()}" ref="right"
         style="width: 40px;position: absolute;right: -62px;top:30px;"
         v-if="isfocus && showButton">
      <div class="flex-column a-center j-center bg-white"
           style="height:76px; box-shadow: 0px 0px 8px 0px rgba(101, 151, 230, 0.36);">
        <i :style="{color:getUpColor}" @click.stop="onUpClick" class="icon-up fs-18"
           style="cursor: pointer"/>
        <i :style="{color:getDownColor}" @click.stop="onDownClick" class="icon-down fs-18 m-t-15"
           style="cursor: pointer"/>
      </div>
      <div class="flex-column a-center j-center m-t-5 bg-white"
           style="height:40px;box-shadow: 0px 0px 8px 0px rgba(101, 151, 230, 0.36);">
        <i @click.stop="onDelClick" class="icon-delete_facet fs-18"
           style="cursor: pointer;color: #F44336"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDisplayWidget',
  props: {
    isfocus: {
      style: Boolean,
      default: false
    },
    iteminfo: {
      style: Object,
      default: () => {
        return {}
      }
    },
    currectindex: Number,
    len: Number,
    showButton: {
      style: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  computed: {
    getUpColor () {
      if (this.currectindex === 0) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    },
    getDownColor () {
      if (this.len === 0 || this.currectindex === this.len - 1) {
        return '#BBBBBB'
      } else {
        return '#666666'
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // this.$nextTick(() => {
      //   console.log('nextTick  clientHeight...' + this.$refs.sss.clientHeight)
      //   let top = (this.$refs.sss.offsetHeight - 110) / 2
      //
      // })
    },
    onDelClick () {
      this.$emit('ondel')
    },
    onUpClick () {
      this.$emit('onup')
    },
    onDownClick () {
      this.$emit('ondown')
    },
    getMarginTop () {
      if (this.iteminfo.config.topMargin) {
        return this.iteminfo.config.topMargin + 'px'
      } else {
        return '0px'
      }
    },
    getMarginLR () {
      if (this.iteminfo.config.lrMargin) {
        return this.iteminfo.config.lrMargin + 'px'
      } else {
        return '0px'
      }
    },
    //电话组件底部悬浮的情况
    getTop () {
      if (this.iteminfo.config.isFloat === 1) { //底部悬浮
        return 0 + 'px'
      } else if (this.iteminfo.config.isFloat === 2) { //底部悬浮
        return -60 + 'px'
      } else if (this.iteminfo.config.isFloat === 3) { //底部悬浮
        return -30 + 'px'
      } else {  //默认
        let top = 0
        if (this.$refs.sss) {
          top = (this.$refs.sss.offsetHeight - 110) / 2
          this.$nextTick(() => {
            top = (this.$refs.sss.offsetHeight - 110) / 2
            if (this.$refs.left)
              this.$refs.left.style.top = top > 0 ? top : 0 + 'px'
            if (this.$refs.right)
              this.$refs.right.style.top = top > 0 ? top : 0 + 'px'
          })
        }
        if (top < 0)
          top = 0
        return top + 'px'
      }
      return 0 + 'px'
    },
    handleResize ({width, height}) {
      if (this.iteminfo.config.isFloat === 1) { //底部悬浮
        if (this.$refs.left)
          this.$refs.left.style.top = '0px'
        if (this.$refs.right)
          this.$refs.right.style.top = '0px'
      } else if (this.iteminfo.config.isFloat === 2) { //底部悬浮
        if (this.$refs.left)
          this.$refs.left.style.top = '-60px'
        if (this.$refs.right)
          this.$refs.right.style.top = '-60px'
      } else {
        let top = (height - 110) / 2
        if (top < 0)                              //只有底部悬浮,才可能为负数
          top = 0
        if (this.$refs.left)
          this.$refs.left.style.top = top + 'px'
        if (this.$refs.right)
          this.$refs.right.style.top = top + 'px'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .base_obj_style {
    border: 1px solid transparent;

    .menu_left {
      display: none;
    }

    &:hover {
      .menu_left {
        display: flex;
      }
    }

  }

  .selectitemstyle {
    border: 1px solid #2672ff;
  }

  .selectitemstyleleft {
    z-index: 999;
  }
</style>
